module.exports = __webpack_public_path__ + "07_mustache_grey.778cfda8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/07_mustache_grey.png
// module id = jKTP
// module chunks = 0